import React from 'react';
import FilterModal from './FilterModal/FilterModal';

const ProductsFilter = ({filterProducts, filter, selected, ordersFilter }) => {
    return <>
        <FilterModal filterProducts={filterProducts} filter={filter} selected={selected} ordersFilter={ordersFilter}/>
    </>
};

export default ProductsFilter;